import React from "react";
import { Text } from "../Text";
import { VideoThumbnail } from "../VideoThumbnail";
import { CaptionedVideoThumbnailProps as Props } from "./index";

export const CaptionedVideoThumbnail: React.FC<Props> = ({
  caption,
  videoThumbnailProps,
}) => {
  return (
    <>
      <VideoThumbnail {...videoThumbnailProps} />
      <Text fontSize={0} fontWeight={400} lineHeight="22px">
        {caption}
      </Text>
    </>
  );
};
